import React, { Component } from 'react'
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import { Select } from "@blueprintjs/select";
import { 
  Button, MenuItem, Alert, Intent, Divider
} from '@blueprintjs/core';
import Pagination from 'components/Pagination';
import Footer from 'components/Footer';
import Toast from 'helpers/toaster';
import { currencyFormattedAmount } from 'helpers/currency';
let numeral = require('numeral');

@inject('store', 'clientStore', 'serviceTypeStore', 'viewStore') @observer
class ServiceTypesTable extends Component {
  @observable isOpenAddEquipmentDialog = false;
  @observable isDeleteDialogVisible = false;
  @observable service;

  onPaginationChange(newPage) {
    let {
      viewStore: {
        serviceTypeSearch
      }
    } = this.props;
    this.props.viewStore.serviceTypeSearch = {
      ...serviceTypeSearch,
      page: newPage
    };
    this.props.viewStore.serviceTypes();
  }

  handleDeleteCancel() {
    this.isDeleteDialogVisible = false;
  }

  handleDeleteConfirm() {
    this.isDeleteDialogVisible = false;
    this.props.serviceTypeStore.deleteServiceType(this.service)
      .then(this.onSuccessfulDeleteServiceType.bind(this))
      .catch(this.onFailDeleteServiceType.bind(this))
  }

  onSuccessfulDeleteServiceType(response) {
    Toast.show({ icon: 'thumbs-up', message: 'Service type deleted successfully!', intent: Intent.SUCCESS })
    this.service = null;
    this.isDeleteDialogVisible = false;
  }

  onFailDeleteServiceType(error) {
    this.isDeleteDialogVisible = false;
    Toast.show({ icon: 'warning-sign', message: 'Unable to delete service type!', intent: Intent.DANGER })
  }

  handleServiceTypeClick(event, service) {
    switch (event.label) {
      case 'Edit':
        this.service = service;
        this.props.viewStore.serviceTypeShow({uuid: service.attributes.id})
        break;
      case 'Delete':
        this.isDeleteDialogVisible = true;
        this.service = service;
        break;
      default:
    }
  }

  copyServiceType(service) {
    let {
      props: {
        serviceTypeStore: {
          serviceTypeDetail,
          serviceTypeDetail: { 
            object
           }
        }
      }
    } = this;

    serviceTypeDetail.object = service;
    serviceTypeDetail.object.id = '';
    serviceTypeDetail.object.service_type_pricing_parameters_attributes = [];
    serviceTypeDetail.object.service_frequencies_attributes = [];
    if(serviceTypeDetail.object.service_type_pricing_parameters){
      serviceTypeDetail.object.service_type_pricing_parameters && serviceTypeDetail.object.service_type_pricing_parameters.map((values) => {
        return(
          serviceTypeDetail.object.service_type_pricing_parameters_attributes.push({
            service_type_id:values.service_type_id,
            pricing_parameter_id:values.pricing_parameter_id,
            label:values.label
          })
        )
      })
    }

    if(serviceTypeDetail.object.service_frequencies){
      serviceTypeDetail.object.service_frequencies && serviceTypeDetail.object.service_frequencies.map((values) => {
        return(
          serviceTypeDetail.object.service_frequencies_attributes.push({
            frequency_id:values.frequency_id,
            service_type_id:values.service_type_id,
            label:values.label
          })
        )
      })
    }

    this.props.serviceTypeStore
      .createServiceType()
      .then(response => {
        Toast.show({
          icon: "thumbs-up",
          message: "Service type copied successfully!",
          intent: Intent.SUCCESS
        });
      })
      .catch(error => {
        Toast.show({
          icon: "warning-sign",
          message: "Unable to copied service type!",
          intent: Intent.DANGER
        });
      });
    

  }

  render() {
    let {
      viewStore,
      serviceTypeStore: {
        serviceType: {
          objects,
          meta
        }
      }
    } = this.props;

    if (objects.length === 0) {
      return ( 
        <div className="bp3-callout bp3-icon-info-sign warning-alert-message bp3-intent-warning">
          <h4 className="bp3-heading">No Results</h4>
          Your search criteria returned no results. Please modify/expand your search parameters to see results.
        </div>
      )
    }
    return (
      <React.Fragment>
        <Footer>
          <div className="bp3-navbar-group bp3-align-left">
            <Pagination
              value={meta.page}
              total={meta.total_pages}
              onChange={this.onPaginationChange.bind(this)}
            />
          </div>
        </Footer>
        <div className="card rounded-0 table-responsive">
          <table className="table table-hover" style={{ width: '100%' }}>
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Rate</th>
                <th className="item-center">Actions</th>
              </tr>
            </thead>
            <tbody>
              {
                objects.map((services) => {
                  return (
                    <tr key={services.id}>
                      <td>{services.attributes.name}</td>
                      <td>{services.attributes.description}</td>
                      <td>{
                        currencyFormattedAmount(services.attributes.rate)
                      }</td>
                      <td>
                        <div className="action-buttons" minimal={true}>
                          <Button title="Copy" minimal={true} small={true} onClick={() => this.copyServiceType(services.attributes)}>
                            <img src="/icon_projects.svg"/>
                          </Button>
                          <Divider/>
                          <Button title="Edit" minimal={true} small={true} onClick={() => viewStore.serviceTypeShow({uuid: services.attributes.id})}>
                            <img src="/edit-light-icon.svg"/>
                          </Button>
                          <Divider/>
                          <Button title="Delete" minimal={true} small={true} onClick={() => this.handleServiceTypeClick({ label: 'Delete' }, services)}>
                            <img src="/delete-light-icon.svg" />
                          </Button>
                        </div>
                      </td>
                    </tr> 
                  )
                })
              }
            </tbody>
          </table>
        </div>
        <Alert
          cancelButtonText="Cancel"
          confirmButtonText="Delete"
          icon="trash"
          intent={Intent.DANGER}
          isOpen={this.isDeleteDialogVisible}
          onCancel={this.handleDeleteCancel.bind(this)}
          onConfirm={this.handleDeleteConfirm.bind(this)}
        >
          <p>
            Warnning! Deleting this service type will not be recoverable.
          </p>
          <p>
            Are you sure you want to do this?
          </p>
        </Alert>
        
        <Footer>
          <div className="bp3-navbar-group bp3-align-left">
            <Pagination
              value={meta.page}
              total={meta.total_pages}
              onChange={this.onPaginationChange.bind(this)}
            />
          </div>
        </Footer>
        
      </React.Fragment>
    )
  }

}

export default ServiceTypesTable;